export default __webpack_public_path__ + "static/media/amandeep.12309a0b.png";